import { connect } from "react-redux";
import { withNamespaces } from "react-i18next";
import customerActions from "../../actions/customer";
import organisationActions from "../../actions/organisation";
import { setDataIsObject } from "../../actions/setDataIsObject";
import Customer from "./Customer";

import { isStateFetching } from "../../utils"

const mapStateToProps = ({ user, customer, organisation }) => ({
  user: user,
  customer: customer.customer,
  organisations: organisation.organisations,
  isFetching: isStateFetching([
    customer,
    organisation
  ])
});

const mapDispatchToProps = {
  ...customerActions,
  ...organisationActions,
  setDataIsObject
};

const connected = connect(mapStateToProps, mapDispatchToProps)(Customer);
export default withNamespaces(["common"])(connected);
